import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=420f24ad&scoped=true&"
var script = {}
import style0 from "./Blog.vue?vue&type=style&index=0&id=420f24ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f24ad",
  null
  
)

export default component.exports